// Shared chart palette for all data visualizations on the new company page
// (forecasting + demographics). Uses the Brand Basil green scale so the
// company page never uses reds/oranges/yellows. Ordered darkest → lightest
// so the top/largest item gets the strongest shade (Primary 700) and
// successive items step toward lighter shades.

export const COMPANY_PAGE_CHART_COLORS = [
  '#087443', // 700 (Primary)
  '#0A9150', // 600
  '#16B364', // 500
  '#39CE7E', // 400
  '#72E3A3', // 300
  '#AAF0C4', // 200
]

export function getCompanyPageChartColor(index: number): string {
  return COMPANY_PAGE_CHART_COLORS[index % COMPANY_PAGE_CHART_COLORS.length]
}
